import React, { useState, useEffect } from "react";
import "./tour.styles.scss";
import Card from "../card/card.component";
import TourFrame from "../tour-frame/tour-frame.component";
import Advertisement from "../advertisement/advertisement.component";
import TourPreview from "../tour-preview/tour-preview.component";
import {
  GetPropertiesFromFirebase,
  GetUnitsFromFirebase,
  GetViewsFromFirebase,
  SubmitPropertyDetailsInRealTime,
  SubmitUnitDetailsInRealTime,
  SubmitPropertyImagePreviewInRealTime,
  SubmitSelectedUnitUrlInRealTime,
  RemoveSelectedUnitUrlInRealTime,
  RemoveSelectedUnitIdInRealTime,
} from "../../firebase/firebase.utils";
import PreviewCard from "../preview-card/preview-card.component";

const Tour = ({ hostJoined, hostDetails, room, guest, snapshotObj }) => {
  const previewDefault = require("../../resources/images/hero-1.jpg");
  const [view, setView] = useState("");
  const [showProperties, setShowProperties] = useState(false);
  const [showUnits, setShowUnits] = useState(false);
  const [showViews, setShowViews] = useState(false);
  const [loading, setLoading] = useState(false);
  const [propertiesList, setPropertiesList] = useState([]);
  const [unitsList, setUnitsList] = useState([]);
  const [viewsList, setViewsList] = useState([]);
  const [property, setProperty] = useState("");
  const [guestUnit, setGuestUnit] = useState("");
  const [guestProperty, setGuestProperty] = useState("");
  const [propertyPreviewUrl, setPropertyPreviewUrl] = useState(previewDefault);
  const [selectedPropertyName, setSelectedPropertyName] = useState("");
  const [selectedUnitUrl, setSelectedUnitUrl] = useState("");
  const [userStartedTour, setUserStartedTour] = useState(true);
  const [ad, setAd] = useState({
    name: "The Bennington",
    location: "Petaling Jaya",
    imageFile: "apartment1.jpg",
  });

  useEffect(() => {
    if (hostJoined && hostDetails.length) {
      const defaultProperty = propertiesList[0];
      setPropertyPreviewUrl(defaultProperty.imageUrl);
      setSelectedPropertyName(defaultProperty.name);
    }
  }, [hostDetails, hostJoined]);

  //When Real Time - Snapshot Object changes
  useEffect(() => {
    if (snapshotObj) {
      if (snapshotObj.unitId) {
        setGuestUnit(snapshotObj.unitId);
      } else {
        setViewsList([]);
      }

      if (userStartedTour) {
        //This statement prevents users who already started viewing a property from constantly refreshing their  view when snapshot updates
        setView(snapshotObj.selectedUnitUrl);
        setUserStartedTour(false);
      }

      setSelectedUnitUrl(snapshotObj.selectedUnitUrl);

      if (snapshotObj.imageUrl) {
        setPropertyPreviewUrl(snapshotObj.imageUrl);
      }

      if (snapshotObj.apartmentName) {
        setSelectedPropertyName(snapshotObj.apartmentName);
      }

      if (snapshotObj.apartmentId) {
        setGuestProperty(snapshotObj.apartmentId);
      }
    }
  }, [snapshotObj]);

  //If a unit is set by host, the default unit view is set to that unit for all users
  useEffect(() => {
    if (selectedUnitUrl) {
      setView(selectedUnitUrl);
    }
  }, [selectedUnitUrl]);

  //If user is the host, show Properties tab
  useEffect(() => {
    if (hostDetails.length) {
      const hostId = hostDetails[0].hostId;
      const promise = GetPropertiesFromFirebase(hostId);
      promise.then((properties) => {
        if (properties) {
          setPropertiesList(properties);
          setShowProperties(true);
        } else {
          console.log("NO PROPERTIES FOUND FOR SPECIFIED USER");
        }
      });
    }
  }, [hostDetails, room]);

  //If user is a guest, hide Properties and Units tab
  useEffect(() => {
    if (guest.length) {
      console.log("GUEST VIEW");
      setShowProperties(false);
      setShowUnits(false);
      if (guestProperty && guestUnit) {
        const promise = GetViewsFromFirebase(guestProperty, guestUnit);
        promise.then((views) => {
          if (views) {
            setViewsList(views);
            setShowViews(true);
          } else {
            console.log("NO VIEWS");
          }
        });
      }
    }
  }, [guest, guestUnit, guestProperty]);

  const PropertySelect = async (details) => {
    const { id, imageUrl, name } = details;
    const propertyId = id.trim();

    //When a property is selected by host, the tour is restarted
    setUserStartedTour(false);

    //To update Guest perspective, need to submit to RT - Database
    SubmitPropertyImagePreviewInRealTime(room, imageUrl);
    setPropertyPreviewUrl(imageUrl);
    setProperty(propertyId);

    //Displays the available units in that property
    const promise = GetUnitsFromFirebase(propertyId);
    promise.then((units) => {
      if (units) {
        setUnitsList(units);
        setShowProperties(false);
        setShowUnits(true);
        //To update Guest perspective, need to submit to RT - Database
        SubmitPropertyDetailsInRealTime(room, propertyId, name);
      } else {
        console.log("NO UNITS");
      }
    });
  };

  const UnitSelect = async (details) => {
    const { id, url } = details;
    if (!id) return;
    const unitId = id.trim();
    const promise = GetViewsFromFirebase(property, unitId);
    promise.then((views) => {
      if (views) {
        setViewsList(views);
        setShowViews(true);
        setShowProperties(false);
        setShowUnits(false);

        //To update Guest perspective, need to submit to RT - Database
        SubmitUnitDetailsInRealTime(room, unitId);
        SubmitSelectedUnitUrlInRealTime(room, url);
      } else {
        console.log("NO VIEWS");
      }
    });
  };

  const ViewSelect = (details) => {
    const { id } = details;
    const index = viewsList.findIndex((view) => view.viewId === id);
    if (index >= 0) {
      const viewUrl = viewsList[index].url;
      if (viewUrl) {
        setView(viewUrl);
      } else {
        console.log("url does not exist");
      }
    }
  };

  //Add an overlay of 3s while waiting for Cupix to load..
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, [view]);

  const adList = [
    {
      name: "The Bennington",
      location: "Petaling Jaya",
      imageFile: "apartment1.jpg",
    },
    { name: "Aparta", location: "Penang", imageFile: "apartment2.jpg" },
    { name: "La Villa", location: "Johor", imageFile: "apartment3.jpg" },
    {
      name: "FourStones",
      location: "Kuala Lumpur",
      imageFile: "apartment4.jpg",
    },
    { name: "Toulo", location: "Subang Jaya", imageFile: "apartment5.jpg" },
  ];

  return (
    <div className="tour">
      <span className="hero-title">LiveTour</span>
      <div className="tour-area">
        {hostJoined ? (
          viewsList.length ? (
            <TourFrame view={view} />
          ) : (
            <TourPreview
              propertyPreviewUrl={propertyPreviewUrl}
              selectedPropertyName={selectedPropertyName}
            />
          )
        ) : (
          <Advertisement ad={ad} />
        )}
        {loading ? <div className="tour-area-overlay">LOADING...</div> : null}
      </div>

      {hostJoined ? (
        <div className="tour-function-bar">
          <div className="tour-settings">
            {hostDetails.length ? (
              <button
                className={`${showProperties ? "active" : ""}`}
                onClick={() => {
                  setShowProperties(true);
                  setShowUnits(false);
                  setShowViews(false);
                  setUnitsList([]);
                  setViewsList([]);
                  RemoveSelectedUnitUrlInRealTime(room);
                  RemoveSelectedUnitIdInRealTime(room);
                }}
              >
                Properties
              </button>
            ) : null}

            {unitsList.length && hostDetails ? (
              <button
                className={`${showUnits ? "active" : ""}`}
                onClick={() => {
                  setShowUnits(true);
                  setShowProperties(false);
                  setShowViews(false);
                  setViewsList([]);
                }}
              >
                Units
              </button>
            ) : null}

            {viewsList.length ? (
              <button
                className={`${showViews ? "active" : ""}`}
                onClick={() => {
                  setShowViews(true);
                  setShowProperties(false);
                }}
              >
                Views
              </button>
            ) : null}
          </div>

          <div className="tour-cards">
            {showProperties && propertiesList.length ? (
              <div className="tour-properties">
                {propertiesList.map((property) => (
                  <Card
                    details={property}
                    key={property.id}
                    handle={PropertySelect}
                  />
                ))}
              </div>
            ) : null}

            {showUnits && unitsList.length ? (
              <div className="tour-units">
                {unitsList.map((unit) => (
                  <Card key={unit.id} details={unit} handle={UnitSelect} />
                ))}
              </div>
            ) : null}

            {showViews && viewsList.length ? (
              <div className="tour-views">
                {viewsList.map((view) => (
                  <Card key={view.id} details={view} handle={ViewSelect} />
                ))}
              </div>
            ) : null}
          </div>
        </div>
      ) : loading ? null : (
        <div className="ad-preview-list">
          {adList.map((ad) => (
            <PreviewCard
              key={ad.imageFile}
              adDetails={ad}
              handleClick={setAd}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Tour;
